module.exports = __webpack_public_path__ + "static/img/12.7e7237c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/12.jpg
// module id = RbPU
// module chunks = 0